// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import store from './store'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)
import 'swiper/css/swiper.css'

// import AMap from 'AMap'
// Vue.use(AMap)
// import Vconsole from 'vconsole'
import { dateFormat, dateFor } from './filter/index'
import 'babel-polyfill'
// import FastClick from 'fastclick'
import lazyLoad from 'vue-LazyLoad'
Vue.use(lazyLoad, {
  loading: require('../static/img/load.svg')
})
// 解决移动端延迟300ms
// FastClick.attach(document.body)
Vue.use(Element)
Vue.filter('dateFormat', dateFormat)
Vue.filter('dateFor', dateFor)
Vue.config.productionTip = false

var _hmt = _hmt || []
window._hmt = _hmt;
(function() {
  var hm = document.createElement('script')
  hm.src = 'https://hm.baidu.com/hm.js?c548b12ad18eab36720099a9495737c7'
  var s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(hm, s)
})()
// Vue.prototype.$vConsole = new Vconsole()
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js